import css from 'styled-jsx/css';

export const styles = css`
  .Loader {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 100;
    background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;
